import React, { useCallback, useEffect, useState } from 'react';
interface NavbarProps {
  handlePurchase: () => void;
}
// Inline SVG icons — eliminates lucide-react from critical bundle (~40kb savings)
function MenuIcon() {
  return <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-209">
      <line x1="4" y1="6" x2="20" y2="6" data-id="element-210" />
      <line x1="4" y1="12" x2="20" y2="12" data-id="element-211" />
      <line x1="4" y1="18" x2="20" y2="18" data-id="element-212" />
    </svg>;
}
function CloseIcon() {
  return <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-213">
      <line x1="18" y1="6" x2="6" y2="18" data-id="element-214" />
      <line x1="6" y1="6" x2="18" y2="18" data-id="element-215" />
    </svg>;
}
export function Navbar({
  handlePurchase
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = useCallback(() => setIsOpen(false), []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) closeMenu();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeMenu]);
  return <>
      <nav className="sticky top-0 z-[9999] bg-[#0A0A0B]/95 border-b border-[#D4AF37]/15 h-[60px] sm:h-[70px] flex items-center justify-between px-4 sm:px-[5%]" role="navigation" aria-label="Navegación principal" style={{
      contain: 'layout style'
    }} data-id="element-216">
        <div className="font-serif italic text-[#D4AF37] text-lg sm:text-xl font-bold tracking-[2px]" data-id="element-217">
          EL CÓDIGO 888
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center" data-id="element-218">
          <a href="#la-frecuencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-[#D4AF37] mr-5" data-id="element-219">
            La Frecuencia
          </a>
          <a href="#la-ciencia" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-[#D4AF37] mr-5" data-id="element-220">
            La Ciencia
          </a>
          <a href="#testimonios" className="text-white text-[11px] font-bold uppercase tracking-[1.5px] transition-colors hover:text-[#D4AF37] mr-5" data-id="element-221">
            Resultados
          </a>
          <a href="#hoy-te-llevas" className="text-[#D4AF37] text-[11px] font-extrabold uppercase border-b-2 border-[#D4AF37] pb-[2px] mr-5" data-id="element-222">
            Hoy Te Llevas
          </a>
          <a href="#protocolo" className="bg-[#D4AF37] text-[#0A0A0B] text-[11px] font-extrabold px-6 py-2.5 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] hover:scale-105 transition-transform uppercase tracking-wide inline-block" data-id="element-223">
            ACTIVAR - $14
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button className="lg:hidden text-[#D4AF37] p-2" onClick={toggleMenu} aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isOpen} aria-controls="mobile-menu" data-id="element-224">
          {isOpen ? <CloseIcon data-id="element-225" /> : <MenuIcon data-id="element-226" />}
        </button>
      </nav>

      {/* Mobile Overlay */}
      {isOpen && <div id="mobile-menu" role="dialog" aria-modal="true" aria-label="Menú de navegación" className="fixed inset-0 top-[60px] bg-[#0A0A0B]/98 z-[9998] flex flex-col items-center pt-12 space-y-8 lg:hidden" data-id="element-227">
          <a href="#la-frecuencia" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-228">
            La Frecuencia
          </a>
          <a href="#la-ciencia" onClick={toggleMenu} className="text-white text-sm font-bold uppercase tracking-[2px]" data-id="element-229">
            La Ciencia
          </a>
          <a href="#hoy-te-llevas" onClick={toggleMenu} className="text-[#D4AF37] text-sm font-extrabold uppercase tracking-[2px]" data-id="element-230">
            Hoy Te Llevas
          </a>
          <a href="#protocolo" onClick={toggleMenu} className="mt-4 bg-[#D4AF37] text-[#0A0A0B] text-sm font-extrabold px-8 py-3 rounded shadow-[0_4px_15px_rgba(212,175,55,0.3)] uppercase tracking-wide inline-block" data-id="element-231">
            Acceso por $14
          </a>
        </div>}
    </>;
}